<template>
  <div></div>
</template>
<script lang="ts">
  export default {
    name: 'TemplatePreview'
  }
</script>
<script setup lang="ts">
  // 测试访问链接：http://localhost:8084/#/template-preview/1150851542086193152
  import { useRoute, useRouter } from 'vue-router'
  import { useProject, useUser, useEvent } from '@haohan/clw-store'
  import { getPreviewPage, getRouterPushUrl, showTemplatePreviewInfo } from '@haohan/clw-utils'
  import { useTemplate } from '@haohan/clw-hooks'
  const route = useRoute()
  const router = useRouter()
  const projectStore = useProject()
  const { initInfoByTemplateId } = useTemplate()

  onBeforeMount(async () => {
    // 获取模板id
    const templateId = route.params.templateId
    if (templateId) {
      // 设置状态
      showTemplatePreviewInfo(templateId as string)
      await initInfoByTemplateId({})
      const previewPage = getPreviewPage(projectStore.pages)
      // 跳转到预览页
      router.push({
        path: getRouterPushUrl({
          preFix: previewPage?.variables?.pageType === 'bigScreen' ? 'bigscreen' : 'preview',
          pageId: previewPage.id
        })
      })
    } else {
      router.push({ path: '/404' })
    }
  })
</script>
<style lang="scss" scoped></style>
